export function fetchMeusPagamentosBadge () {
  const base = (process.env.VUE_APP_UPFYGATE || '').replace(/\/$/, '')
  if (!base) {
    return Promise.resolve({ success: false, show: false })
  }
  return window.Vue.$httpCookiesOnly
    .get(`${base}/meus-pagamentos/Badge`)
    .then((resp) => {
      const d = resp.data || {}
      const level = d.level
      if (!level || level === 'None') {
        return { success: true, show: false }
      }
      return {
        success: true,
        show: true,
        level,
        days: d.days
      }
    })
    .catch(() => ({ success: false, show: false }))
}
